// extracted by mini-css-extract-plugin
export default {"container":"ImageRenderer_container__opRC8"};